"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortenAddressText = exports.AddressText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const react_2 = require("@chakra-ui/react");
const helpers_1 = require("../../helpers");
function AddressText(_a) {
    var { addressText, isFullText = false, children, textProps, iconProps } = _a, props = __rest(_a, ["addressText", "isFullText", "children", "textProps", "iconProps"]);
    const containerRef = react_1.default.useRef(null);
    const copyToClipboardRef = react_1.default.useRef(null);
    const [displayedAddressText, setDisplayedAddressText] = react_1.default.useState(() => addressText);
    react_1.default.useEffect(() => {
        var _a, _b, _c;
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && (copyToClipboardRef === null || copyToClipboardRef === void 0 ? void 0 : copyToClipboardRef.current) && addressText) {
            const offsetW = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
            const scrollW = (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth;
            if (scrollW > offsetW) {
                const copyW = (_c = copyToClipboardRef === null || copyToClipboardRef === void 0 ? void 0 : copyToClipboardRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth;
                const shortened = shortenAddressText(offsetW - copyW, scrollW, addressText);
                setDisplayedAddressText(shortened);
            }
        }
    }, [addressText, containerRef, copyToClipboardRef]);
    return ((0, jsx_runtime_1.jsxs)(react_2.HStack, Object.assign({ bgColor: "gray.100", rounded: "md", px: 2, py: 1, fontSize: "md", ref: containerRef }, props, { children: [(0, jsx_runtime_1.jsx)(react_2.Text, Object.assign({ fontFamily: "monospace", "aria-label": "public address", title: addressText, onCopy: e => {
                    e.clipboardData.setData("text/plain", addressText);
                    e.preventDefault();
                } }, textProps, { children: children
                    ? children
                    : isFullText
                        ? displayedAddressText
                        : (0, helpers_1.makeShortId)(addressText) })), (0, jsx_runtime_1.jsx)(__1.CopyToClipboard, { toCopy: addressText, iconProps: iconProps, containerProps: { ref: copyToClipboardRef } })] })));
}
exports.AddressText = AddressText;
const ELLIPSIS_SIZE = 2;
function shortenAddressText(offsetWidth, scrollWidth, addressText) {
    const isValid = (0, __1.validateAddress)(addressText);
    if (isValid !== true)
        throw new Error(isValid);
    if (offsetWidth >= scrollWidth)
        return addressText;
    const addressLen = addressText.length;
    const halfLen = Math.round(addressLen / 2);
    const avgCharSize = Math.round(scrollWidth / addressLen);
    const charsToRemove = Math.round((scrollWidth - offsetWidth) / Math.round(avgCharSize)) +
        ELLIPSIS_SIZE;
    const first = addressText.slice(0, halfLen - charsToRemove / 2);
    const second = addressText.slice(halfLen + charsToRemove / 2);
    return first + "..." + second;
}
exports.shortenAddressText = shortenAddressText;
